
import { CSSProperties, defineComponent, PropType } from 'vue';
// TODO: 支持长按显示用户列表

export default defineComponent({
  props: {
    /** emoji */
    emoji: { type: String, required: true },
    /** 数目 */
    count: { type: Number, default: 0 },
    /** 激活态 */
    active: { type: Boolean, default: false },
    /** emoji 样式 */
    emojiStyle: { type: Object as PropType<CSSProperties>, default: {} },
    /** 数目样式 */
    countStyle: { type: Object as PropType<CSSProperties>, default: {} },
  },
});
